<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-bottom-10">
            <a href="/question-set-f">
                <img :src="'images/mpower-new/career/back-arrow.png'" />
            </a>
        </div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}}
            </div>
        </div>
        <div v-for="first in data[loadIndex].firsthalf" class="content" :key="first.index">
            <div class="talent-appraisal-category talent-category text-left">{{first.section}}</div>
            <div class="talent-appraisal-category talent-category-title">{{first.title}}</div>
            <div class="talent-appraisal-category"></div>
            <div>
                <label class="talent-radio-wrapper" :class="first.name=='1'?'career-label-highlight':''"><input v-model="first.name" value="1" class="talent-radio" type="radio"  style="display:none" @click="check(first.section.toLowerCase(),1,1)"/> 1</label>
                <label class="talent-radio-wrapper" :class="first.name=='2'?'career-label-highlight':''"><input v-model="first.name" value="2" class="talent-radio" type="radio"  style="display:none" @click="check(first.section.toLowerCase(),2,1)"/> 2</label>
                <label class="talent-radio-wrapper" :class="first.name=='3'?'career-label-highlight':''"><input v-model="first.name" value="3" class="talent-radio" type="radio"  style="display:none" @click="check(first.section.toLowerCase(),3,1)"/> 3</label>
                <label class="talent-radio-wrapper" :class="first.name=='4'?'career-label-highlight':''"><input v-model="first.name" value="4" class="talent-radio" type="radio"  style="display:none" @click="check(first.section.toLowerCase(),4,1)"/> 4</label>
                <label class="talent-radio-wrapper" :class="first.name=='5'?'career-label-highlight':''"><input v-model="first.name" value="5" class="talent-radio" type="radio"  style="display:none" @click="check(first.section.toLowerCase(),5,1)"/> 5</label>
                <label class="talent-radio-wrapper" :class="first.name=='6'?'career-label-highlight':''"><input v-model="first.name" value="6" class="talent-radio" type="radio"  style="display:none" @click="check(first.section.toLowerCase(),6,1)"/> 6</label>
                <label class="talent-radio-wrapper" :class="first.name=='7'?'career-label-highlight':''"><input v-model="first.name" value="7" class="talent-radio" type="radio"  style="display:none" @click="check(first.section.toLowerCase(),7,1)"/> 7</label>
            </div>
            <div class="talent-indication-wrapper text-left">{{data[loadIndex].min}}</div>
            <div class="talent-indication-wrapper text-right">{{data[loadIndex].max}}</div>
        </div>
        <div class="talent-appraisal-divider margin-top-30 margin-bottom-30"></div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}}
            </div>
        </div>
        <div v-for="second in data[loadIndex].secondhalf" class="content" :key="second.index">
            <div class="talent-appraisal-category talent-category text-left">{{second.section}}</div>
            <div class="talent-appraisal-category talent-category-title">{{second.title}}</div>
            <div class="talent-appraisal-category"></div>
            <div>
                <label class="talent-radio-wrapper" :class="second.name=='1'?'career-label-highlight':''"><input v-model="second.name" value="1" class="talent-radio" type="radio"  style="display:none" @click="check(second.section.toLowerCase(),1,2)"/> 1</label>
                <label class="talent-radio-wrapper" :class="second.name=='2'?'career-label-highlight':''"><input v-model="second.name" value="2" class="talent-radio" type="radio"  style="display:none" @click="check(second.section.toLowerCase(),2,2)"/> 2</label>
                <label class="talent-radio-wrapper" :class="second.name=='3'?'career-label-highlight':''"><input v-model="second.name" value="3" class="talent-radio" type="radio"  style="display:none" @click="check(second.section.toLowerCase(),3,2)"/> 3</label>
                <label class="talent-radio-wrapper" :class="second.name=='4'?'career-label-highlight':''"><input v-model="second.name" value="4" class="talent-radio" type="radio"  style="display:none" @click="check(second.section.toLowerCase(),4,2)"/> 4</label>
                <label class="talent-radio-wrapper" :class="second.name=='5'?'career-label-highlight':''"><input v-model="second.name" value="5" class="talent-radio" type="radio"  style="display:none" @click="check(second.section.toLowerCase(),5,2)"/> 5</label>
                <label class="talent-radio-wrapper" :class="second.name=='6'?'career-label-highlight':''"><input v-model="second.name" value="6" class="talent-radio" type="radio"  style="display:none" @click="check(second.section.toLowerCase(),6,2)"/> 6</label>
                <label class="talent-radio-wrapper" :class="second.name=='7'?'career-label-highlight':''"><input v-model="second.name" value="7" class="talent-radio" type="radio"  style="display:none" @click="check(second.section.toLowerCase(),7,2)"/> 7</label>
            </div>
            <div class="talent-indication-wrapper text-left">{{data[loadIndex].min}}</div>
            <div class="talent-indication-wrapper text-right">{{data[loadIndex].max}}</div>
        </div>
        <div class="content">
            <hr style="border: 0.5px solid #7C7B7B;"/>
            <br/>
            <table class="table-style">
                <tr>
                    <td rowspan="0" style="width:30%">GRAND TOTAL</td>
                </tr>
                <tr>
                    <td>{{setg}}</td>
                    <td>{{sete}}</td>
                    <td>{{setn}}</td>
                    <td>{{setl}}</td>
                    <td>{{sett}}</td>
                    <td>{{setp}}</td>
                </tr>
                <tr class="redbold">
                    <td>G</td>
                    <td>E</td>
                    <td>N</td>
                    <td>L</td>
                    <td>T</td>
                    <td>P</td>
                </tr>
            </table>
            <a @click="proceed()" class="generali-button-red">
                {{data[loadIndex].button}}
            </a>
        </div>
    </div>
</template>
<style scoped>
.talent-appraisal-category {
    width:33.33%;
    display:inline-block !important;
}
/* .talent-category {
    font-size: 14px;
    color: #FFC461;
} */
.talent-category-title {
    font-size: 10px;
    color: #7C7B7B;
    vertical-align: super;
}
.talent-radio-wrapper {
    width: 14.25%;
    display: inline-block !important;
    color: #7C7B7B;
    height: 32px;
    line-height: normal;
    padding: 10px 0;
    border: 1px solid #7C7B7B;
    font-size: 9px;
}
.talent-radio {
    -webkit-appearance: none !important;
}
.talent-indication-wrapper {
    width:49.5%;
    display:inline-block !important;
    font-size: 10px;
    /* color:rgb(255,255,255,0.7); */
    color: #c9c9c9;
}
.talent-appraisal-divider {
    background:#000000;
    height: 2px;
}
</style>
<script>
export default {
    name: "Question_set_g",
    data(){
        return {
            setg1: '',
            sete1: '',
            setn1: '',
            setl1: '',
            sett1: '',
            setp1: '',
            setg2: '',
            sete2: '',
            setn2: '',
            setl2: '',
            sett2: '',
            setp2: '',
            setgdata:[],
            setedata:[],
            setndata:[],
            setldata:[],
            settdata:[],
            setpdata:[],
            setg:0,
            sete:0,
            setn:0,
            setl:0,
            sett:0,
            setp:0,
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "title": "IV. Self-Appraisal",
                "description": "According to your perceived ability on each of the following categories, kindly put your score with number 1 to 7 (High = 7, Average = 4, Low = 1). Avoid granting yourself the same score in each category.",
                "firsthalf": [{
                    "index": "g",
                    "section": "G",
                    "title": "Mechanical",
                    "name": "setg1"
                },{
                    "index": "e",
                    "section": "E",
                    "title": "Scientific",
                    "name": "sete1"
                },{
                    "index": "n",
                    "section": "N",
                    "title": "Artistic",
                    "name": "setn1"
                },{
                    "index": "l",
                    "section": "L",
                    "title": "Teaching",
                    "name": "setl1"
                },{
                    "index": "t",
                    "section": "T",
                    "title": "Sales",
                    "name": "sett1"
                },{
                    "index": "p",
                    "section": "P",
                    "title": "Clerical",
                    "name": "setp1"
                }],
                "secondhalf": [{
                    "index": "a2",
                    "section": "G",
                    "title": "Manual",
                    "name": "setg2"
                },{
                    "index": "l2",
                    "section": "E",
                    "title": "Math",
                    "name": "sete2"
                },{
                    "index": "i2",
                    "section": "N",
                    "title": "Musical",
                    "name": "setn2"
                },{
                    "index": "k2",
                    "section": "L",
                    "title": "Friendliness",
                    "name": "setl2"
                },{
                    "index": "y2",
                    "section": "T",
                    "title": "Managerial",
                    "name": "sett2"
                },{
                    "index": "c2",
                    "section": "P",
                    "title": "Office",
                    "name": "setp2"
                }],
                "min": "Low",
                "max": "High",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "IV. 自我评估",
                "description": "针对下列各个领域, 评估你本身的能力, 不可在各项能力评估中给予同样的评分  7 = 很大能力, 4 = 中等能力, 1 = 最少能力",
                "firsthalf": [{
                    "index": "g",
                    "section": "G",
                    "title": "技术能力",
                    "name": "setg1"
                },{
                    "index": "e",
                    "section": "E",
                    "title": "科学能力",
                    "name": "sete1"
                },{
                    "index": "n",
                    "section": "N",
                    "title": "艺术能力",
                    "name": "setn1"
                },{
                    "index": "l",
                    "section": "L",
                    "title": "教导能力",
                    "name": "setl1"
                },{
                    "index": "t",
                    "section": "T",
                    "title": "销售能力",
                    "name": "sett1"
                },{
                    "index": "p",
                    "section": "P",
                    "title": "文书能力",
                    "name": "setp1"
                }],
                "secondhalf": [{
                    "index": "g2",
                    "section": "G",
                    "title": "操作能力",
                    "name": "setg2"
                },{
                    "index": "e2",
                    "section": "E",
                    "title": "数学能力",
                    "name": "sete2"
                },{
                    "index": "n2",
                    "section": "N",
                    "title": "音乐能力",
                    "name": "setn2"
                },{
                    "index": "l2",
                    "section": "L",
                    "title": "态度友善",
                    "name": "setl2"
                },{
                    "index": "t2",
                    "section": "T",
                    "title": "管理技巧",
                    "name": "sett2"
                },{
                    "index": "p2",
                    "section": "P",
                    "title": "办公技巧",
                    "name": "setp2"
                }],
                "min": "低",
                "max": "高",
                "button": "继续"
            },{
                "language": "bm",
                "title": "IV. Penilaian Diri",
                "description": "Tandakan skor keupayaan anda pada setiap kategori berikut. Elakkan daripada memberikan diri anda markah yang sama dalam setiap kategori. Skor Keupayaan dari 1 hingga 7 (Tinggi = 7 , Sederhana = 4 , Rendah = 1)",
                "firsthalf": [{
                    "section": "G",
                    "title": "Mekanikal",
                    "name": "setg1"
                },{
                    "section": "E",
                    "title": "Saintifik",
                    "name": "sete1"
                },{
                    "section": "N",
                    "title": "Artistik",
                    "name": "setn1"
                },{
                    "section": "L",
                    "title": "Mengajar",
                    "name": "setl1"
                },{
                    "section": "T",
                    "title": "Jualan",
                    "name": "sett1"
                },{
                    "section": "P",
                    "title": "Perkeranian",
                    "name": "setp1"
                }],
                "secondhalf": [{
                    "section": "G",
                    "title": "Manual"
                },{
                    "section": "E",
                    "title": "Matematik"
                },{
                    "section": "N",
                    "title": "Muzikal"
                },{
                    "section": "L",
                    "title": "Peramah"
                },{
                    "section": "T",
                    "title": "Pengurusan"
                },{
                    "section": "P",
                    "title": "Pejabat"
                }],
                "min": "Rendah",
                "max": "Tinggi",
                "button": "Teruskan"
            }]
        }
    },
    computed: {
        returnInputBinding(char,val){
            return 'set'+char+val
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        check(set,value,question) {
            if(set=='g'){
                this.setgdata[question]=value;
                this.setg=0;
                if(question==1){
                    this.setg1=value;
                }else{
                    this.setg2=value;
                }
                this.setgdata.forEach((index) => {
                    this.setg+=index;
                });
            }
            if(set=='e'){
                this.setedata[question]=value;
                this.sete=0;
                if(question==1){
                    this.sete1=value;
                }else{
                    this.sete2=value;
                }
                this.setedata.forEach((index) => {
                    this.sete+=index;
                });
            }
            if(set=='n'){
                this.setndata[question]=value;
                this.setn=0;
                if(question==1){
                    this.setn1=value;
                }else{
                    this.setn2=value;
                }
                this.setndata.forEach((index) => {
                    this.setn+=index;
                });
            }
            if(set=='l'){
                this.setldata[question]=value;
                this.setl=0;
                if(question==1){
                    this.setl1=value;
                }else{
                    this.setl2=value;
                }
                this.setldata.forEach((index) => {
                    this.setl+=index;
                });
            }
            if(set=='t'){
                this.settdata[question]=value;
                this.sett=0;
                if(question==1){
                    this.sett1=value;
                }else{
                    this.sett2=value;
                }
                this.settdata.forEach((index) => {
                    this.sett+=index;
                });
            }
            if(set=='p'){
                this.setpdata[question]=value;
                this.setp=0;
                if(question==1){
                    this.setp1=value;
                }else{
                    this.setp2=value;
                }
                this.setpdata.forEach((index) => {
                    this.setp+=index;
                });
            }
        },
        proceed(){
            this.conclusion.g4 = 0;
            this.conclusion.e4 = 0;
            this.conclusion.n4 = 0;
            this.conclusion.l4 = 0;
            this.conclusion.t4 = 0;
            this.conclusion.p4 = 0;

            if(parseInt(this.setg1) > 0){
                this.conclusion.g4 += parseInt(this.setg1);
            }
            if(parseInt(this.sete1) > 0){
                this.conclusion.e4 += parseInt(this.sete1);
            }
            if(parseInt(this.setn1) > 0){
                this.conclusion.n4 += parseInt(this.setn1);
            }
            if(parseInt(this.setl1) > 0){
                this.conclusion.l4 += parseInt(this.setl1);
            }
            if(parseInt(this.sett1) > 0){
                this.conclusion.t4 += parseInt(this.sett1);
            }
            if(parseInt(this.setp1) > 0){
                this.conclusion.p4 += parseInt(this.setp1);
            }
            if(parseInt(this.setg2) > 0){
                this.conclusion.g4 += parseInt(this.setg2);
            }
            if(parseInt(this.sete2) > 0){
                this.conclusion.e4 += parseInt(this.sete2);
            }
            if(parseInt(this.setn2) > 0){
                this.conclusion.n4 += parseInt(this.setn2);
            }
            if(parseInt(this.setl2) > 0){
                this.conclusion.l4 += parseInt(this.setl2);
            }
            if(parseInt(this.sett2) > 0){
                this.conclusion.t4 += parseInt(this.sett2);
            }
            if(parseInt(this.setp2) > 0){
                this.conclusion.p4 += parseInt(this.setp2);
            }
            localStorage.setItem('talent_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            this.$router.push({path: 'talent-result'})
        }
    }
}
</script>